import home from './src/home.vue'

import PassengerFlow from './src/passengerflow.vue' //客流监测
import TrafficFlow from './src/trafficflow.vue' //车流监测
import PassengerFlowGb from './src/passengerflowGb.vue' //客流监测
import passengerflowGbHy from './src/passengerflowGbHy.vue' //华阳客流监测
import TrafficFlowGb from './src/trafficflowGb.vue' //车流监测

let views = {
    home,
    PassengerFlow,
    TrafficFlow,
    PassengerFlowGb,
    passengerflowGbHy,
    TrafficFlowGb
};

export default views;